export const LEGAL_NATURE_LIST_LOAD = "LEGAL_NATURE_LIST_LOAD"; 
